import { Alert, Input, Modal } from 'antd';
import React from 'react';
import { Template } from '../../../interfaces/backend/Template';
import { TemplatesPOSTRequest } from '../../../interfaces/backend/TemplatesPOSTRequest';
import Paragraph from 'antd/lib/typography/Paragraph';
import stripDisallowedIdCharacters from '../../../utils/stripDisallowedIdCharacters';
import { AxiosError } from 'axios';

interface Props {
  createTemplate: (
    channel: string,
    params: TemplatesPOSTRequest
  ) => Promise<void>;
  templateBeingDuplicated?: Template;
  setTemplateBeingDuplicated: (template?: Template) => void;
}

const TemplateDuplication = (props: Props): JSX.Element => {
  const [duplicationTemplateId, setDuplicationTemplateId] = React.useState('');
  const [duplicationRunning, setDuplicationRunning] = React.useState(false);
  const [duplicationError, setDuplicationError] = React.useState('');

  const submitHandler = async () => {
    if (props.templateBeingDuplicated === undefined) return;

    setDuplicationRunning(true);
    const requestBody = {
      ...props.templateBeingDuplicated,
      envId: undefined,
      notificationId: undefined,
      default: undefined,
      channel: undefined,
      isDefaultFor: undefined,
      templateId: duplicationTemplateId
    } as unknown as TemplatesPOSTRequest;

    try {
      await props.createTemplate(
        props.templateBeingDuplicated?.channel,
        requestBody
      );
      props.setTemplateBeingDuplicated(undefined);
      setDuplicationRunning(false);
    } catch (e) {
      setDuplicationRunning(false);
      const error = e as AxiosError;
      if (
        error.response?.data.message &&
        error.response?.data.message.includes('duplicate templateId')
      ) {
        setDuplicationError('There is already a template with this ID.');
      } else {
        throw e;
      }
    }
  };

  return (
    <Modal
      title="Duplicate Template"
      open={props.templateBeingDuplicated ? true : false}
      onOk={submitHandler}
      okButtonProps={{
        disabled: duplicationTemplateId === '',
        loading: duplicationRunning
      }}
      onCancel={() => {
        props.setTemplateBeingDuplicated(undefined);
      }}
    >
      <Paragraph>New Template ID (cannot be changed later):</Paragraph>
      <Input
        value={duplicationTemplateId}
        placeholder='e.g. "nike_spanish"'
        onChange={(e) =>
          setDuplicationTemplateId(stripDisallowedIdCharacters(e.target.value))
        }
        onPressEnter={submitHandler}
      />
      {duplicationError && (
        <Alert
          style={{ marginTop: '8px' }}
          message={duplicationError}
          type="error"
        />
      )}
    </Modal>
  );
};

export default TemplateDuplication;
